module.exports = __webpack_public_path__ + "static/img/harddevelop1.fba3e4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/hard/harddevelop1.jpg
// module id = xQpS
// module chunks = 0